import React from 'react';

interface ToggleInputProps {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  className?: string;
  dataTestId?: string;
}

/**
 * Composant Toggle standardisé pour les formulaires
 * Style uniforme avec switch toggle animé
 */
export const ToggleInput: React.FC<ToggleInputProps> = ({
  label,
  value,
  onChange,
  disabled = false,
  className = '',
  dataTestId,
}) => {
  return (
    // `tw-gap-3` : sans effet visible en pleine largeur (`justify-between` écarte déjà
    // les deux éléments), mais garantit un espacement si un conteneur réduit le
    // composant à sa taille de contenu — libellé et bouton se touchaient alors.
    <div className={`tw-flex tw-items-center tw-justify-between tw-gap-3 ${className}`}>
      <span className="tw-text-sm tw-font-medium tw-text-gray-700">
        {label}
      </span>
      <button
        type="button"
        role="switch"
        aria-checked={value}
        data-testid={dataTestId}
        onClick={() => !disabled && onChange(!value)}
        disabled={disabled}
        className={`
          tw-relative tw-inline-flex tw-h-6 tw-w-11 tw-flex-shrink-0 tw-cursor-pointer
          tw-rounded-full tw-border-2 tw-border-transparent tw-transition-colors
          tw-duration-200 tw-ease-in-out focus:tw-outline-none focus:tw-ring-2
          focus:tw-ring-affinicar-primary focus:tw-ring-offset-2
          ${value ? 'tw-bg-affinicar-primary' : 'tw-bg-gray-200'}
          ${disabled ? 'tw-opacity-50 tw-cursor-not-allowed' : ''}
        `}
      >
        <span
          aria-hidden="true"
          className={`
            tw-pointer-events-none tw-inline-block tw-h-5 tw-w-5 tw-transform
            tw-rounded-full tw-bg-white tw-shadow tw-ring-0 tw-transition
            tw-duration-200 tw-ease-in-out
            ${value ? 'tw-translate-x-5' : 'tw-translate-x-0'}
          `}
        />
      </button>
    </div>
  );
};
